import { render } from "./HeroiconsOutlineChatAlt.vue?vue&type=template&id=7dbdd982"
const script = {}

import exportComponent from "/Users/dorinpuscasu/Desktop/Projects/linella/linella-backend/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineChatAlt.vue"]])

export default __exports__